import './i18n';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { CookieConsent } from './components/CookieConsent';
import { initResourceDispatcher } from './resources/commands/resourceDispatcher';
import { initAdrDispatcher } from './adr/commands/adrDispatcher';
import { initEmployeeDispatcher } from './employees/commands/employeeDispatcher';
import { initTeamDispatcher } from './teams/commands/teamDispatcher';
import { initCategoryDispatcher } from './taskCategories/commands/categoryDispatcher';
import './index.css';

initResourceDispatcher();
initAdrDispatcher();
initEmployeeDispatcher();
initTeamDispatcher();
initCategoryDispatcher();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // Temporarily disabled StrictMode to debug infinite loop
  // <React.StrictMode>
    <>
      <RouterProvider router={router} />
      <CookieConsent />
    </>
  // </React.StrictMode>,
);
